var map = {
	"./frontend/Home.vue": 9233,
	"./frontend/Index.vue": 6635,
	"./frontend/Live.vue": 7412,
	"./frontend/MainMenu.vue": 9673,
	"./frontend/VideoLink.vue": 9327,
	"./frontend/normal-user/Index.vue": 5531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;